<!--
 * @Author: Alfred huqitaoit@gmail.com
 * @Date: 2023-12-15 13:55:19
 * @LastEditors: Alfred
 * @LastEditTime: 2023-12-15 14:27:14
 * @Description:
 * @FilePath: \src\components\order\OrderSignAuditDetail.vue
-->

<template>
  <div class="order-signing-detail">
    <!-- <div class="table-header fn-clear">
      <div class="fn-right export-btn">
        <el-button type="success" @click="exportExcel">导出Excel表</el-button>
      </div>
      <div class="fn-right table-header-right">
        <el-pagination
          :current-page.sync="search.p"
          :page-sizes="[10, 20, 30, 40, 50,100, 300,400,500]"
          :page-size="search.limit"
          layout="sizes, prev, slot, next"
          prev-text="上一页"
          next-text="下一页"
          :total="itemTotal"
          @size-change="handleSizeChange"
        >
          <div class="chax">
            {{ search.p }}/{{
              itemTotal > 0 ? Math.ceil(itemTotal / search.limit) : 1
            }}
          </div>
        </el-pagination>
      </div>
    </div> -->
    <div class="tuolele-main-box">
      <el-table ref="singleTable" :data="dataInfo.list" border stripe highlight-current-row @sort-change="tableSort">
        <el-table-column prop="out_trade_no" label="签约单号" sortable />
        <el-table-column prop="create_time" label="创建时间" sortable>
          <template slot-scope="scope">
            <div class="color-black">
              {{ scope.row.create_time.substr(0, 16) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="modify_time" label="最后操作时间" sortable>
          <template slot-scope="scope">
            <div class="color-black">
              {{ scope.row.modify_time.substr(0, 16) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="店铺">
          <template slot-scope="scope">
            <div class="color-black">{{ scope.row.shop_name }}</div>
          </template>
        </el-table-column>

        <el-table-column label="套餐价格">
          <template slot-scope="scope">
            <div class="color-black">￥{{ scope.row.amount/100 }}</div>
          </template>
        </el-table-column>
        <el-table-column label="学员ID">
          <template slot-scope="scope">
            <div class="color-black">{{ scope.row.sub_name }}</div>
            <div class="color-gray">{{ scope.row.sub_id }}</div>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="getOrderInfo(scope.row)">{{
              type == "singing" ? "查看订单" : "审核订单"
            }}</el-button>
            <!-- <el-button
              v-if="scope.row.kpi_status_name != '赠送' && scope.row.extra"
              type="text"
              @click="orderImg(scope.row)"
            >电子合同</el-button> -->
            <!-- <el-button
              v-if="scope.row.invoice_status != '0' && type == 'singing'"
              type="text"
              @click="getInvoice(scope.row, '1')"
            >查看发票</el-button> -->
            <!-- <el-button
              v-if="scope.row.invoice_status == '0' && type == 'singing'"
              type="text"
              @click="setInvoice(scope.row, '0')"
            >编辑发票</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="订单详情"
      :visible.sync="dialogVisible1"
      width="40%"
      :before-close="handleClose"
      class="order-detail-dialog"
    >
      <BillingSigningInfo
        :key="orderDetail.out_trade_no"
        :order-detail="orderDetail"
        :type="type"
        @updateOrderList="getSignList"
      />
    </el-dialog>
    <!-- <el-dialog
      title="发票信息"
      :visible.sync="dialogVisible2"
      width="40%"
      :before-close="handleClose"
      class="order-detail-invoice"
    >
      <div class="order-detail-item">
        <div class="color-black bold font-size16 order-detail-item-title">
          类型
        </div>
        <el-radio-group
          v-if="invoiceFlag == '0'"
          v-model="invoiceDetail.invoice_type"
        >
          <el-radio :label="1">增值税普票</el-radio>
          <el-radio :label="2">增值税专票</el-radio>
        </el-radio-group>

        <div v-if="invoiceFlag == '1'">
          {{ invoiceDetail.invoice_type == "1" ? "增值税普票" : "增值税专票" }}
        </div>
      </div>
      <div class="order-detail-item">
        <div class="color-black bold font-size16 order-detail-item-title">
          税率
        </div>
        <el-radio-group
          v-if="invoiceFlag == '0'"
          v-model="invoiceDetail.invoice_tax_rate"
        >
          <el-radio :label="1">1%</el-radio>
          <el-radio :label="3">3%</el-radio>
          <el-radio :label="6">6%</el-radio>
        </el-radio-group>
        <div v-if="invoiceFlag == '1'">
          {{ invoiceDetail.invoice_tax_rate + "%" }}
        </div>
      </div>
      <div class="order-detail-item">
        <div class="color-black bold font-size16 order-detail-item-title">
          发票号
        </div>
        <div v-if="invoiceFlag == '1'">{{ invoiceDetail.invoice_no }}</div>
        <el-input
          v-if="invoiceFlag == '0'"
          v-model="invoiceDetail.invoice_no"
          clearable
        />
      </div>
      <el-button
        v-if="invoiceFlag == '1'"
        type="primary"
        class="el-button-confirm"
        @click="handleClose()"
      >确定</el-button>
      <el-button
        v-if="invoiceFlag == '0'"
        type="primary"
        class="el-button-confirm"
        @click="confirmSetInvoice"
      >确定</el-button>
    </el-dialog> -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible3"
      title="合同预览"
      class="order-img"
    >
      <div class="agreement_picture">
        <div class="pdf">
          <iframe
            :src="src"
            frameborder="0"
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import BillingSigningInfo from '@/components/order/BillingSigningInfo.vue';
export default {
  name: 'OrderSignAuditDetail',
  components: {
    BillingSigningInfo
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    search: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dataInfo: {},
      itemTotal: 0,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      orderDetail: {},
      invoiceDetail: {
        order_id: '',
        invoice_type: '1',
        invoice_no: '',
        invoice_tax_rate: '6'
      },
      invoiceFlag: '0',
      src: ''
    }
  },
  watch: {
    search: {
      deep: true,
      handler() {
        this.getSignList()
      }
    }
  },
  mounted() {
    console.log('---------')
    this.getSignList()
  },
  methods: {

    getSignList() {
      this.dialogVisible1 = false
      this.$http.getBillingAuditList(this.search).then(res => {
        this.dataInfo = res.data
        this.itemTotal = res.data.count - 0
      })
    },
    getOrderInfo(row) {
      this.$http.getBillingDetail({ out_trade_no: row.out_trade_no }).then(res => {
        this.orderDetail = res.data.orderInfo
        console.log(this.orderDetail)
        this.dialogVisible1 = true
      })
    },
    getInvoice(row, val) {
      this.$http.getInvoice({ order_id: row.order_id }).then(res => {
        this.invoiceDetail = res.data
        this.invoiceFlag = val
        this.dialogVisible2 = true
      })
    },
    setInvoice(row, val) {
      this.invoiceFlag = val
      this.invoiceDetail = {}
      this.invoiceDetail.order_id = row.order_id
      this.dialogVisible2 = true
    },
    confirmSetInvoice() {
      const invoiceDetail = {
        order_id: this.invoiceDetail.order_id,
        invoice_type: this.invoiceDetail.invoice_type,
        invoice_no: this.invoiceDetail.invoice_no,
        invoice_tax_rate: this.invoiceDetail.invoice_tax_rate
      }
      for (const key in invoiceDetail.invoice) {
        if (!invoiceDetail.invoice[key]) {
          this.$message({
            type: 'info',
            message: '请完善发票信息'
          })
          return
        }
      }
      this.$http.setInvoice(invoiceDetail).then(res => {
        if (res.code == '200') {
          this.dialogVisible2 = false
          this.$message({
            type: 'success',
            message: '编辑发票信息成功'
          })
          this.getSignList()
        }
      })
    },
    orderImg(row) {
      this.$refs.singleTable.setCurrentRow(row)
      this.dialogVisible3 = true
      this.src = row.extra.order_img
    },
    handleClose() {
      this.dialogVisible1 = false
      this.dialogVisible2 = false
      this.dialogVisible3 = false
    },
    tableSort(val) {
      this.search.order_key = val.prop
      this.search.order_sort =
        val.order == 'ascending' ? '4' : val.order == 'descending' ? '3' : ''
      this.search.p = 1
      this.getSignList()
    },
    handleSizeChange(val) {
      this.search.limit = val
    }
  }
}
</script>

<style lang="scss">
.el-icon-circle-close{
  color:white!important
}
.order-signing-detail {
  .export-btn {
    margin: 0 40px;
  }
  .flex-con {
    margin-right: 30px;
  }
  .flex-con:last-child {
    margin-right: 0;
  }
  .order-count {
    height: 160px;
    color: #fff;
    padding: 30px 0 0 30px;
    margin: 0 auto;
    background: url(../../assets/img/price-bg.png) #4c84ff right bottom
      no-repeat;
    background-size: 96px 117px;
    border-radius: 10px;
    span {
      font-size: 20px;
      margin-bottom: 25px;
    }
    p {
      font-size: 40px;
    }
  }
  .table-header {
    margin-bottom: 20px;
  }
  .el-table td {
    border: 1px solid #f5f5f5;
  }
  .order-detail-invoice {
    .el-dialog__body {
      padding: 20px 40px;
    }
    div {
      margin-bottom: 15px;
    }
    .el-input {
      width: 240px;
    }
  }
  .order-img .el-dialog {
    height: 95% !important;
    .el-dialog__body {
      height: 90%;
    }
    .agreement_picture,
    .pdf {
      height: 100%;
    }
  }
}
</style>
